import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { EmbedScreen } from './routes/EmbedScreen';
import { FlowLinkScreen } from './routes/FlowLinkScreen';
import { HomeScreen } from './routes/HomeScreen';
import { LinkScreen } from './routes/LinkScreen';
import { PreviewFlowScreen } from './routes/PreviewFlowScreen';
import { PreviewScreen } from './routes/PreviewScreen';
import { ResumeScreen } from './routes/ResumeScreen';
import { SdkScreen } from './routes/SdkScreen';
import { StatusScreen } from './routes/StatusScreen';
import { VerifyScreen } from './routes/VerifyScreen';
import { Shell } from './ui/Shell';

/**
 * Applicant SPA routes.
 *
 * - `/` — product home when bare; with `?token=` starts the flow (desktop handoff).
 * - `/u/:code` — the shareable applicant link; `code` is the token, re-encoded.
 * - `/l/:linkId` — a workflow's reusable link: starts (or resumes) a session,
 *   then continues at `/u/:code`.
 * - `/verify?token=` — explicit session entry (same runner as root with token).
 * - `/resume/:token` — mobile QR handoff landing (no second QR); `token` is a
 *   22-char code, decoded by `ResumeScreen`.
 * - `/preview/consent` — the consent screen as the console's branding settings
 *   preview it (inert; branding arrives by postMessage).
 * - `/preview/flow` — one step of a draft workflow as the console's workflow
 *   builder previews it (the step arrives by postMessage; an act on it reports
 *   its event back, and nothing entered is sent anywhere).
 */
export function App() {
  return (
    <BrowserRouter>
      <Shell>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/verify" element={<VerifyScreen />} />
          <Route path="/u/:code" element={<FlowLinkScreen />} />
          <Route path="/l/:linkId" element={<LinkScreen />} />
          <Route path="/embed" element={<EmbedScreen />} />
          <Route path="/sdk/u/:code" element={<SdkScreen />} />
          <Route path="/preview/consent" element={<PreviewScreen />} />
          <Route path="/preview/flow" element={<PreviewFlowScreen />} />
          <Route path="/resume/:token" element={<ResumeScreen />} />
          <Route path="/status/:status" element={<StatusScreen />} />
          <Route path="*" element={<StatusScreen />} />
        </Routes>
      </Shell>
    </BrowserRouter>
  );
}
